export default __webpack_public_path__ + "static/media/flu.651eb691.jpg";